<template>
  <div class="container-fluid" @contextmenu.prevent="selectBtn" style="padding:0;">
    <tab></tab>
    <div class="row">
      <div id="carousel-example-generic1" class="carousel slide index-top-web" :class="{'hidden-xs hidden-sm':isShowWeb}" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carousel-example-generic1" :data-slide-to="index" :class="{'active':index=='0'}" v-for="(item,index) in chanceBanner" :key="index"></li>
        </ol>
        <!-- Wrapper for slides -->
        <div class="carousel-inner" role="listbox">
          <div class="item" :class="{'active':index=='0'}" v-for="(item,index) in chanceBanner" :key="index">
            <img :src="item.pic_urlStr" alt="#" class="inner-item-img"/>

            <div class="inner-item-center">
              <div class="item-center-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="item-center-tips">{{lanType==1?item.sub_title:item.sub_titleEn}}</div>
            
              <div class="item-center-btn" @click="goPage(item)">{{lanType==1?'了解更多':'Learn more'}}</div>
            </div>
          </div>

          <!-- <div class="item">
            <img src="@/images/banner.jpg" alt="#" class="inner-item-img"/>

            <div class="inner-item-center">
              <div class="item-center-title">京东物流成国内首个承诺科学碳目标物流企业</div>
              <div class="item-center-tips">10月22日，京东物流在北京798艺术中心递交了科学碳目标倡议书，成为国内首家承诺加入科学碳目标倡议的物流企业。</div>
            
              <div class="item-center-btn">了解更多</div>
            </div>
          </div> -->

        </div>
      </div>

      <div id="carousel-example-generic2" class="carousel slide index-top-phone hidden-md hidden-lg" v-if="isShowWeb&&chanceBanner.length>0" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carousel-example-generic2" :data-slide-to="index" :class="{'active':index=='0'}" v-for="(item,index) in chanceBanner" :key="index"></li>
        </ol>

        <div class="carousel-inner" role="listbox">
          <div class="item" :class="{'active':index=='0'}" v-for="(item,index) in chanceBanner" :key="index">
            <img :src="item.pic_urlStr" alt="#" class="phone-inner-img"/>

            <div class="phone-inner-center">
              <div class="phone-center-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="phone-center-tips">{{lanType==1?item.sub_title:item.sub_titleEn}}</div>
            
              <div class="phone-center-btn" @click="goPage(item)">{{lanType==1?'了解更多':'Learn more'}}</div>
            </div>
          </div>

          <!-- <div class="item">
            <img src="@/images/banner.jpg" alt="#" class="phone-inner-img"/>

            <div class="phone-inner-center">
              <div class="phone-center-title">京东物流成国内首个承诺科学碳目标物流企业</div>
              <div class="phone-center-tips">10月22日，京东物流在北京798艺术中心递交了科学碳目标倡议书，成为国内首家承诺加入科学碳目标倡议的物流企业。</div>
            
              <div class="phone-center-btn">了解更多</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <div class="row" v-if="pageId!=10&&pageId!=12">
      <div class="index-neck" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="web-index-neck" v-if="projectInfo.parent_id==12">{{lanType==1?'课程介绍':'Introduction'}}</div>
        <div class="web-index-neck" v-else>{{lanType==1?projectInfo.title:projectInfo.titleEn}}</div>

        <div class="index-neck-tips" v-html="lanType==1?projectInfo.content:projectInfo.contentEn"></div>
      
        <div id="carousel-example-generic3" class="carousel slide index-neck-web hidden-xs hidden-sm" data-ride="carousel" v-if="pageProjectList&&pageProjectList.pcData&&pageProjectList.pcData.length>0">
          <ol class="carousel-indicators index-neck-indicators">
            <li data-target="#carousel-example-generic3" :data-slide-to="index" :class="{'active':index=='0'}" v-for="(item,index) in pageProjectList.pcData" :key="index"></li>
          </ol>
          <!-- Wrapper for slides -->
          <div class="carousel-inner" role="listbox">
            <div class="item" :class="{'active':index=='0'}" v-for="(item,index) in pageProjectList.pcData" :key="index">
              <div class="index-neck-item spaceBetween">
                <div class="columnCenter" :class="res.hover||res.titleList.length==0?'hiddenHover':'neck-item-list'" v-for="(res,i) in item" :key="i" @click="queryPage(res)">
                  <img :src="res.picStr" alt="#" class="item-list-img">
                  <div class="item-list-font color1">{{lanType==1?res.title:res.titleEn}}</div>
                  <div class="item-list-btns">
                    <div class="list-btns-btn color1 border1" v-for="(data,num) in res.titleList" :key="num" @click.stop="queryPage(data)">{{lanType==1?data.title:data.title_supEn}}</div>
                    <!-- <div class="list-btns-btn color1 border1">SBTi资料</div>
                    <div class="list-btns-btn color1 border1">SBTi活动回顾</div> -->
                  </div>
                </div>

                <!-- <div class="neck-item-list columnCenter">
                  <img src="@/images/banner.jpg" alt="#" class="item-list-img">
                  <div class="item-list-font color2">RE买家联盟</div>
                  <div class="item-list-btns">
                    <div class="list-btns-btn color2 border2">SBTi训练营</div>
                    <div class="list-btns-btn color2 border2">SBTi资料</div>
                    <div class="list-btns-btn color2 border2">SBTi活动回顾</div>
                  </div>
                </div> -->

              </div>
            </div>
          </div>

          <a class="left neck-btn-left middle" href="#carousel-example-generic3" role="button" data-slide="prev">
            <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
          </a>
          <a class="right neck-btn-right middle" href="#carousel-example-generic3" role="button" data-slide="next">
            <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
          </a>
        </div>
        <div class="index-neck-btn" v-if="pageId==19" @click="goChanceList">{{lanType==1?'开始':'Get Started'}}</div>
      </div>

      <div class="phone-neck hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-index-neck">{{lanType==1?'项目介绍':'Climate Solvers'}}</div>

        <div class="phone-neck-tips" v-html="lanType==1?projectInfo.content:projectInfo.contentEn"></div>
      
        <div id="carousel-example-generic4" class="carousel slide index-neck-web" data-ride="carousel">
          <ol class="carousel-indicators phone-neck-indicators">
            <li data-target="#carousel-example-generic4" :data-slide-to="index" :class="{'active':index=='0'}" v-for="(item,index) in pageProjectList.data" :key="index"></li>
          </ol>
          <!-- Wrapper for slides -->
          <div class="carousel-inner" role="listbox">
            <div class="item" :class="{'active':index=='0'}" v-for="(item,index) in pageProjectList.data" :key="index">
              <div class="phone-neck-item spaceBetween">
                <div class="phone-item-list columnCenter" v-for="(res,i) in item" :key="i" @click="queryPage(res)">
                  <img :src="res.picStr" alt="#" class="phone-item-img">
                  <div class="phone-item-font color1">{{lanType==1?res.title:res.titleEn}}</div>
                  <div class="phone-item-btns">
                    <div class="phone-btns-btn color1 border1" v-for="(data,num) in res.titleList" :key="num" @click.stop="queryPage(data)">{{lanType==1?data.title:data.titleEn}}</div>
                    <!-- <div class="phone-btns-btn color1 border1">SBTi资料</div>
                    <div class="phone-btns-btn color1 border1">SBTi活动回顾</div> -->
                  </div>
                </div>

                <!-- <div class="phone-item-list columnCenter">
                  <img src="@/images/banner.jpg" alt="#" class="phone-item-img">
                  <div class="phone-item-font color2">RE买家联盟</div>
                  <div class="phone-item-btns">
                    <div class="phone-btns-btn color2 border2">SBTi训练营</div>
                    <div class="phone-btns-btn color2 border2">SBTi资料</div>
                    <div class="phone-btns-btn color2 border2">SBTi活动回顾</div>
                  </div>
                </div> -->
              </div>
            </div>

            <!-- <div class="item">
              <div class="phone-neck-item spaceBetween">

                <div class="phone-item-list columnCenter">
                  <img src="@/images/banner.jpg" alt="#" class="phone-item-img">
                  <div class="phone-item-font color3">气候创行者</div>
                  <div class="phone-item-btns">
                    <div class="phone-btns-btn color3 border3">SBTi训练营</div>
                    <div class="phone-btns-btn color3 border3">SBTi资料</div>
                    <div class="phone-btns-btn color3 border3">SBTi活动回顾</div>
                  </div>
                </div>

                <div class="phone-item-list columnCenter">
                  <img src="@/images/banner.jpg" alt="#" class="phone-item-img">
                  <div class="phone-item-font color4">加入CBH</div>
                  <div class="phone-item-btns">
                    <div class="phone-btns-btn color4 border4">SBTi训练营</div>
                    <div class="phone-btns-btn color4 border4">SBTi资料</div>
                    <div class="phone-btns-btn color4 border4">SBTi活动回顾</div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="chance-neck" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="web-index-neck">{{projectBlock2.title}}</div>
        <div class="index-neck-tips">{{projectBlock2.content}}</div>
        <div class="web-chance-center spaceBetween wrap">
          <div class="chance-center-list middle" v-for="(item,index) in enterprisesList" :key="index">
            <img :src="item.picStr" alt="#" class="center-list-list"/>
          </div>
        </div>
      </div>

      <div class="chance-neck hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-index-neck">{{projectBlock2.title}}</div>
        <div class="phone-neck-tips">{{projectBlock2.content}}</div>

        <div class="phone-chance-center spaceBetween wrap">
          <div class="phone-chance-center-list middle" v-for="(item,index) in enterprisesList" :key="index">
            <img :src="item.picStr" alt="#" class="phone-center-list-list"/>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row" v-if="pageId==10||pageId==12">
      <div class="index-belly" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="web-index-neck" v-if="pageId==12">{{lanType==1?'课程介绍':'Introduction'}}</div>
        <!-- <div class="index-neck-tips" v-html="projectInfo.content"></div> -->
        <div class="index-belly-center spaceBetween centerWrap">
          <div class="belly-center-all spaceBetween" v-for="(item,index) in pageProjectList.pcData" :key="index">
            <div class="belly-center-div spaceBetween" v-for="(res,i) in item" :key="i" @click="queryPage(res)">
              <div class="belly-center-list">
                <div class="center-list-li">
                  <img :src="res.picStr" alt="#" class="list-li-img"/>
                  <div class="list-li-layer">
                    <div class="li-layer-font" style="white-space: pre-wrap;">{{lanType==1?res.brief:res.briefEn}}</div>
                    <div class="li-layer-title fontHidden">{{lanType==1?'阅读更多':'Read more'}}</div>
                  </div>
                </div>
              </div>
              <img src="@/images/right.png" alt="#" class="belly-center-icon" :class="{'center-icon-hidden':index+1==pageProjectList.pcData.length&&i+1==item.length}"/>
            </div>
          </div>
        </div>
        
      </div>

      <div class="phone-neck hidden-md hidden-lg" v-if="isShowWeb">
        <!-- <div class="phone-index-neck">项目介绍</div> -->
        <!-- <div class="phone-neck-tips" v-html="projectInfo.content"></div> -->
        <div class="phone-belly-centerImg spaceBetween centerWrap">
          <div class="phone-belly-imgList" v-for="(item,index) in pageProjectList.data" :key="index">
            <div class="phone-belly-imgLi" v-for="(res,i) in item" :key="i" @click="queryPage(res)">
              <img :src="res.picStr" alt="#" class="phone-belly-imgs"/>
              <div class="phone-belly-layer">
                <div class="phone-belly-font">{{lanType==1?res.brief:res.briefEn}}</div>
                <div class="phone-belly-title fontHidden">{{lanType==1?res.title:res.titleEn}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
      <div class="" :class="{'hidden-xs hidden-sm':isShowWeb}">
        <div class="web-belly-center">
          <img :src="indexBg" v-show="videoPlay=='end'" alt="#" class="belly-center-img"/>
          <img src="@/images/playBtn.png" v-show="videoPlay=='start'" alt="#" class="belly-center-imgBtn"/>
          <video-player class="video-player belly-center-img vjs-custom-skin"
            v-show="videoPlay=='start'||videoPlay=='play'"
            ref="videoPlayer" 
            :playsinline="true"
            @ended="onPlayerEnded($event)"
            :options="playerOptions"
          ></video-player>
          <div class="web-belly-content" v-show="videoPlay=='end'">
            <div class="belly-content-top">
              <div class="belly-top-font" @click="toReplay">
                <img src="@/images/play.png" alt="#" class="belly-top-img"/>
                <div class="belly-top-tips">重播视频</div>
              </div>
            </div>
            <div class="belly-content-center spaceBetween">
              <div class="content-center-list" v-for="(item,index) in indexVideos" :key="index"> 
                <div class="center-list-video" @click="choiceVideo(index)">
                  <img :src='item.picStr' alt="#" class="list-video-real" style="width:100%;"/>
                </div>
                <div class="center-list-font">{{item.title}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hidden-md hidden-lg" v-if="isShowWeb">
        <div class="phone-index-neck">视频</div>

        <div id="carousel-example-generic5" class="carousel slide phone-belly-center" data-ride="carousel">

          <div class="carousel-inner" role="listbox" style="height:100%;">

            <div class="swiper-slide item" :class="{'active':index=='0'}" v-for="(item,index) in indexVideos" :key="index"  @click="playVideo(index)">
              <img :src="item.picStr" v-show="videoPlay=='start'||videoPlay=='end'" alt="#" class="phone-belly-img"/>
              <img src="@/images/playBtn.png" v-show="videoPlay=='start'||videoPlay=='end'" alt="#" class="belly-center-imgBtn phone-belly-imgBtn"/>
              <video id="pcVideo0" preload="auto" :poster='item.picStr' :src="item.contentStr" controls="controls" class="phone-belly-img pcVideo">
                您的浏览器不支持 video 标签。
              </video>
            </div>
          </div>

        </div>

      </div>
    </div> -->

    <div class="row">
      <div :class="{'hidden-xs hidden-sm':isShowWeb}" v-if="newsList.length>0">
        <div class="web-index-neck">{{lanType==1?'新闻动态':'News'}}</div>

        <div class="web-index-leg spaceBetween">
          <div class="index-leg-left">
            <div class="leg-left-top">
              <img :src="newsList[0].picStr" alt="#" class="leg-left-img">
              <div class="left-top-bottom" >
                <div class="top-bottom-list" v-if="newsList&&newsList.length>0&&newsList[0].title_sup">{{lanType==1?newsList[0].title_sup:newsList[0].title_supEn}}</div>
                <div class="top-bottom-list" v-if="newsList&&newsList.length>0&&newsList[0].title_sub">{{lanType==1?newsList[0].title_sub:newsList[0].title_sub}}</div>
              </div>
            </div>
            <div class="leg-left-center">
              <div class="left-center-title">{{lanType==1?newsList[0].title:newsList[0].titleEn}}</div>
              <div class="left-center-tips">{{lanType==1?newsList[0].brief:newsList[0].briefEn}}</div>
              <div class="left-center-bottom spaceBetween" @click="goMechanism(newsList[0])">
                <div class="center-bottom-left">{{newsList[0].updated_at}}</div>
                <div class="center-bottom-left color1">{{lanType==1?'查看详情':'View details'}}</div>
              </div>
            </div>
          </div>

          <div class="index-leg-right columnBetween">
            <div class="leg-right-list spaceBetween" v-for="(item,index) in newsList" :key="index" v-if="index>0">
              <div class="right-list-left">
                <img :src="item.picStr" alt="#" class="list-left-img">
                <div class="list-left-bottom">
                  <div class="list-left-list" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                  <div class="list-left-list bg1" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
                </div>
              </div>
              <div class="right-list-right columnBetween">
                <div class="list-right-title">{{lanType==1?item.title:item.titleEn}}</div>
                <div class="right-list-bottom spaceBetween" @click="goMechanism(item)">
                  <div class="center-bottom-left list-bottom-left">{{item.updated_at}}</div>
                  <div class="center-bottom-left color1 list-bottom-left">{{lanType==1?'查看详情':'View details'}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="hidden-md hidden-lg" v-if="newsList.length>0&&isShowWeb">
        <div class="phone-index-neck">{{lanType==1?'新闻动态':'News'}}</div>

        <div class="phone-index-leg">
          <div class="phone-leg-top">
            <div class="leg-top-images">
              <img :src="newsList[0].picStr" alt="#" class="top-images-img"/>
              <div class="top-images-list">
                <div class="images-list-li" v-if="newsList&&newsList.length>0&&newsList[0].title_sup">{{lanType==1?newsList[0].title_sup:newsList[0].title_supEn}}</div>
                <div class="images-list-li" v-if="newsList&&newsList.length>0&&newsList[0].title_sub">{{lanType==1?newsList[0].title_sub:newsList[0].title_subEn}}</div>
              </div>
            </div>
            <div class="leg-top-bottom">
              <div class="top-bottom-title">{{lanType==1?newsList[0].title:newsList[0].titleEn}}</div>
              <div class="top-bottom-tips">{{lanType==1?newsList[0].brief:newsList[0].briefEn}}</div>
              <div class="top-bottom-bottom spaceBetween" @click="goMechanism(newsList[0])">
                <div class="bottom-bottom-left ">{{newsList[0].updated_at}}</div>
                <div class="bottom-bottom-left color1">{{lanType==1?'查看详情':'View details'}}</div>
              </div>
            </div>
          </div>

          <div class="phone-leg-list spaceBetween" v-for="(item,index) in newsList" :key="index" v-if="index>0">
            <div class="leg-list-left">
              <img :src="item.picStr" alt="#" class="list-left-img" />
              <div class="phone-list-bottom">
                <div class="images-list-li" v-if="item.title_sup">{{lanType==1?item.title_sup:item.title_supEn}}</div>
                <div class="images-list-li bg1" v-if="item.title_sub">{{lanType==1?item.title_sub:item.title_subEn}}</div>
              </div>
            </div>
            <div class="leg-list-right columnBetween">
              <div class="phone-list-title">{{lanType==1?item.title:item.titleEn}}</div>
              <div class="top-bottom-bottom spaceBetween" @click="goMechanism(item)">
                <div class="bottom-bottom-left ">{{item.updated_at}}</div>
                <div class="bottom-bottom-left color1">{{lanType==1?'查看详情':'View details'}}</div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


    <div class="row">
      <div :class="{'hidden-xs hidden-sm':isShowWeb}" style="position: relative;" v-if="legList.length>0">
        <div class="chance-leg-top middle" @click="isShowLayer=!isShowLayer">
          <img src="@/images/up.png" class="leg-top-img" :class="{'mt':isShowLayer}">
        </div>
        <div class="chance-leg spaceBetween" v-if="isShowLayer">
          <div class="chance-leg-list start" v-for="(item,index) in legList" :key="index" @click="queryPage(item)">
            <img :src="item.picStr" alt="#" class="leg-list-imgs"/>
            <img src="@/images/right.png" alt="#" class="belly-center-icon" v-if="index<legList.length-1"/>
          </div>
        </div>
      </div>
      <div class="hidden-md hidden-lg" style="position: relative;" v-if="legList.length>0">
        <div class="chance-leg-top middle" @click="isShowLayer=!isShowLayer">
          <img src="@/images/up.png" class="leg-top-img" :class="{'mt':isShowLayer}">
        </div>
        <div class="chance-leg spaceBetween wrap" v-if="isShowLayer">
          <div class="phone-chance-leg-list start" v-for="(item,index) in legList" :key="index" @click="queryPage(item)">
            <img :src="item.picStr" alt="#" class="phone-leg-list-imgs"/>
            <img src="@/images/right.png" alt="#" class="phone-belly-center-icon" v-if="index<legList.length-1"/>
          </div>
        </div>
      </div>
    </div>

    <footerBar ref="footerView"></footerBar>
  </div>
</template>

<script>
import tab from '@/components/tab';
import footerBar from '@/components/footerBar';
import axios from 'axios';
import { chunkArr } from '@/utils/util';
import config from '@/utils/config';
import indexBg from '@/images/indexBg.jpg';
export default {
  name: 'activity',
  components: {
    tab:tab,
    footerBar:footerBar
  },
  data () {
    return {
      chanceBanner:{},
      pageId:'',
      projectList:[],
      pageProjectList:[],
      projectBlock:{},
      projectBlock2:{},
      enterprisesList:[],
      newsList:[],
      isShowWeb:config.urlList.isShowWeb,
      videoPlay:'start',
      playerOptions : {
        playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: "video/mp4",//这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
          src: '' //url地址
        }],
        poster: '', //你的封面地址
        // width: document.documentElement.clientWidth, //播放器宽度
        notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true  //全屏按钮
        }
      },
      videosIndex:0,
      videos:'',
      indexVideos:[],
      indexBg:indexBg,
      projectInfo:{},
      parent_id:'',
      legList:[],
      isShowLayer:true,
      lanType:1
    }
  },
  watch:{
    $route(to,from){
      const vm=this;
      vm.pageId=to.query.id;
      location.reload();
      //vm.queryPage(to.query);
    }
  },
  methods:{
    fatherMethod(type){
      const vm=this
      vm.lanType=type
      setTimeout(()=>{
        vm.$refs.footerView.choiceType(type);
      },400)
    },
    selectBtn(){
      const vm=this
      vm.$toast({
        text: '本页禁止右键保存！',
        type: 'danger',
        duration: 1600
      })
    },
    queryPage(item){
      const vm=this;
      if(vm.pageId==10||vm.pageId==10){
        if(localStorage.getItem('CbhuserInfo').is_examine<1){
          vm.$toast({
            text: '您还未通过审核，请通过后再试！',
            type: 'wraning',
            duration: 1600
          })
          return
        }
      }
      vm.$router.push({ path:'/projectDetail',query:{id:item.id}})
      location.reload();
    },
    queryBanner(){
      const vm=this;
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/carousel`,
      {
        type:2,
        project_id:vm.$route.query.id
      }
      ).then(res => {
        if(res.data.code==1){
          res.data.data.forEach(da=>{
            da.titleEn  = da.titleEn?da.titleEn:da.title
            da.sub_titleEn  = da.sub_titleEn?da.sub_titleEn:da.sub_title
            da.pic_urlStr=`${config.urlList.imgUrl}${da.pic_url}`
          })
          vm.chanceBanner=res.data.data
          document.documentElement.scrollTop=0;
        }
      })
    },
    goPage(item){
      const vm=this
      window.open(item.url,'_blank')
    },
    setTitle(da){
      const vm=this
      if(da.titleEn){
        return da
      }
      switch (da.title) {
        case '科学碳目标':
          da.titleEn = "Science Based Target initiative (SBTi)";
          break;
        case '科学碳目标简介':
          da.titleEn = "Introduction";
          break;
        case '设置科学碳目标':
          da.titleEn = "Setting SBTi";
          break;
        case '案例':
          da.titleEn = "Best practice";
          break;
        case '活动':
          da.titleEn = "Events";
          break;
        case '绿色电力需求行动':
          da.titleEn = "China Corporate Renewable Energy Program";
          break;
        case '绿色电力需求倡议':
          da.titleEn = "Renewable Energy Buyers' Principles";
          break;
        case '绿色电力采购评估工具':
          da.titleEn = "Buyers' Evaluation Tool";
          break;
        case '绿色电力应用培训课程':
          da.titleEn = "Buyers' Curriculum";
          break;
        case '绿色电力应用试点项目':
          da.titleEn = "Corporate RE Pilot Project";
          break;
        case '活动':
          da.titleEn = "Events";
          break;
        case '气候创行者':
          da.titleEn = "Climate Solver";
          break;
        case '气候创行者简介':
          da.titleEn = "Introduction";
          break;
        case '加入CBH':
          da.titleEn = "JoinUs";
          break;
        case '绿色电力需求倡议':
          da.titleEn = "Renewable Energy Buyers' Principles";
          break;
        case '绿色电力采购评估工具':
          da.titleEn = "Buyers' Evaluation Tool";
          break;
        case '绿色电力应用培训课程':
          da.titleEn = "Buyers' Curriculum";
          break;
        case '绿色电力应用试点项目':
          da.titleEn = "Corporate RE Pilot Project";
          break;
        case '企业气候行动共同体邀请函':
          da.titleEn = "CBH invitation letter";
          break;
        case '企业共同体组织机制':
          da.titleEn = "CBH Organization mechanism";
          break;
        case '绿色电力需求倡议':
          da.titleEn = "Renewable Energy Buyers' Principles";
          break;
        case '联系方式':
          da.titleEn = "Contact information";
          break;
        default: 
          da.titleEn = da.title;
      }
      return da
    },
    queryProjectList(index){
      const vm=this
      let arr=vm.projectList
      axios.get(`${config.urlList.queryUrl}/api/cbh/project_list/${index}`).then(res => {
        if(res.data.code==1){
          if(index==vm.pageId){
            res.data.data.forEach(da=>{
              da=vm.setTitle(da)
              da.picStr=`${config.urlList.imgUrl}${da.pic}`;
              da.briefEn=da.briefEn?da.briefEn:da.brief;
              da.titleList=[];
              if(da.id!=10&&da.id!=12){
                vm.queryProjectList(da.id)
              }
            })
            vm.projectList=res.data.data;
          }else{
            vm.projectList.forEach(da=>{
              res.data.data.forEach(res=>{
                res=vm.setTitle(res)
                res.picStr=`${config.urlList.imgUrl}${res.pic}`
                if(da.id==res.parent_id){
                  da.titleList.push(res);
                }
              })
            })
            vm.pageProjectList={
              pcData:chunkArr(vm.projectList,4),
              data:chunkArr(vm.projectList,2),
            }
          }
        }
      })
    },
    queryProjectList2(index){
      const vm=this
      let arr=vm.projectList
      axios.get(`${config.urlList.queryUrl}/api/cbh/project_list/${index}`).then(res => {
        if(res.data.code==1){
          res.data.data.forEach(da=>{
            da.picStr=`${config.urlList.imgUrl}${da.pic}`
          })
          vm.legList = res.data.data
        }
      })
    },
    setContent(da){
      const vm=this
      if(da.contentEn){
        return da
      }
      switch (da.id) {
        case 1:
          da.contentEn = "<p>Science Based Target Initiative is a global partnership between CDP, the United Nations Global Compact (UNGC), World Resources Institute (WRI) and WWF. Launched in 2015, the Science Based Targets initiative (SBTi):</p><p>-Defines and promotes best practice in emissions reductions and net-zero targets in line with climate science.</p><p>-Provides technical assistance and expert resources to companies who set science-based targets in line with the latest climate science.</p><p>-Brings together a team of experts to provide companies with independent assessment and validation of targets.</p><p>-The SBTi is the lead partner of the Business Ambition for 1.5°C campaign - an urgent call to action from a global coalition of UN agencies, business and industry leaders, mobilizing companies to set net-zero science-based targets in line with a 1.5°C future.</p>";
          break;
        case 7:
          da.contentEn = "<p>JD Logistics-the first domestic logistics company that promised to join SBTi and set goals</p><p>JDL has committed to reduce 50% carbon emissions by 2030 (starting from 2019). It is also planning to sourcing 100% renewable electricity by 2030.The target was approved and listed on SBTi’s official website on November 12th, 2020.</p><p>JD Logistics is planning to develop a long-term target “zero emissions by 2050” by means of its sustainability strategy called “Green Stream Initiative (GSI)”. Measures will be taken include: increasing of energy efficiency of logistics services, 100% electric vehicle, 100% renewable electricity, developing low carbon products/services, asking suppliers to have SBTs, purchasing from supplier with lower carbon footprint, certifying employees and suppliers as Green Stream specialist，etc.</p>";
          break;
        case 2:
          da.contentEn = "<p>China Corporate Renewable Energy Program (Corporate RE Program) is an action-oriented program led by the World Wide Fund for Nature (WWF) and its strategic partner One Planet Foundation (OPF) of Shenzhen, with the support and participation of various renewable energy stakeholders. The Corporate RE Program aims to scale corporate investment, procurement, and consumption of renewable energy by</p><p>-Developing a community of corporate energy buyers, renewable energy developers, grid companies, and other renewable energy market and policy stakeholders;</p><p>-Identifying challenges and opportunities to scale corporate renewable energy procurement;</p><p>-Providing market intelligence and capacity building for corporate energy buyers;</p><p>-Advocating for broader policy support for renewable energy in a collective voice.</p>";
          break;
        case 3:
          da.contentEn = "<p>Climate Solver is one of WWF's flagship programs in accelerating low carbon transition. Launched in 2008 by WWF Sweden, the program is expanded to China in 2011 and currently active in China, India, South Africa, and Sweden. The program aims to highlight innovative technologies that provide immediate and practical solutions to climate change, connect low-carbon entrepreneurs and innovations from different markets, create a global technology exchange and collaboration platform and accelerate financing and scaling low-carbon innovations.</p><p>Climate Solver selection process and benefits</p><p>Climate Solver program awards SMEs with innovative low-carbon solutions annually through collaboration with industrial parks, investors, and research institutes. Applicants will be evaluated by the emission reduction potential of their innovation and the quality of their business plan.</p><p>WWF will support awarded companies by:</p><p>Increasing the visibility and credibility of the company as a climate innovation leader: WWF will create a video about the awarded innovation and showcase it on the Climate Solver website. WWF will also create opportunities for awarded companies to share their success stories in domestic and international events.</p><p>Accelerating commercialization: WWF will connect awarded companies with CBH members and low carbon city program partners to accelerate the application and commercialization of the awarded innovation.</p><p>Connecting with investors: WWF will provide awarded companies more opportunities to connect with investors throughout the selection process.</p><p>Facilitating international exchange and collaboration: WWF will offer awarded companies opportunities to interact with international peers and similar innovation platforms to exchange information and share best practices through the WWF Network & partners.</p>";
          break;
        default: 
          da.contentEn = da.content;
      }
      return da
    },
    queryProject(){
      const vm=this
      let obj = {
        id:vm.$route.query.id,
        token:localStorage.getItem("Cbhtoken")
      }
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/project`,obj
      ).then(res => {
        if(res.data.code==1){

          res.data.data.content = res.data.data.content ? res.data.data.content.replace(/(width|height)="\d*"\s*/g, '') : ''
          res.data.data.contentEn = res.data.data.contentEn ? res.data.data.contentEn.replace(/(width|height)="\d*"\s*/g, '') : ''
          
          vm.projectInfo=res.data.data
          document.title = vm.projectInfo.title+' ' + localStorage.getItem("CbhTitle")
          if(res.data.data.parent_id==10||res.data.data.parent_id==12){
            vm.parent_id=res.data.data.parent_id
            vm.queryProjectList2(vm.parent_id)
          }
          //vm.queryvideos();
        }else{
          vm.$toast({
            text: '请登录后再试！',
            type: 'danger',
            duration: 1600
          })
          //vm.$router.push({ path:'/'  })
        }
      })
    },
    queryBlock(){
      const vm=this
      axios.get(
      `${config.urlList.queryUrl}/api/cbh/block/1`,
      ).then(res => {
        if(res.data.code==1){
          vm.projectBlock=res.data.data
        }
      })
    },
    queryEnterprisesList(){
      const vm=this
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/enterprises_list`,
      {
        project_id:vm.$route.query.id
      }
      ).then(res => {
        if(res.data.code==1){
          res.data.data.forEach(da=>{
            da.picStr=`${config.urlList.imgUrl}${da.pic}`
          })
          vm.enterprisesList=res.data.data
        }
      })
    },
    queryBlock2(){
      const vm=this
      ///api/cbh/block
      axios.get(
      `${config.urlList.queryUrl}/api/cbh/block/${vm.$route.query.id}`,
      ).then(res => {
        if(res.data.code==1){
          vm.projectBlock2=res.data.data
        }else{
          vm.projectBlock2={}
        }
      })
    },
    queryNewsList(){
      const vm=this
      axios.post(`${config.urlList.queryUrl}/api/cbh/news_list`,{
        type:1,
        project_id:vm.$route.query.id,
        per_page:4,
        is_recommend:0
      }).then(res => {
        if(res.data.code==1){
          res.data.data.data.forEach(da=>{
            da.title_subEn = da.title_subEn?da.title_subEn:da.title_sub
            da.title_supEn = da.title_supEn?da.title_supEn:da.title_sup
            da.titleEn = da.titleEn?da.titleEn:da.title
            da.briefEn = da.briefEn?da.briefEn:da.brief
            da.picStr=`${config.urlList.imgUrl}${da.pic}`;
            da.updated_at=format(new Date(da.updated_at),'YYYY-MM-DD')
          })
          vm.newsList=res.data.data.data
        }
      })
    },
    goMechanism(item){
      const vm=this
      vm.$router.push({ path:'/mechanism',query:{id:item.id,type:1}})
    },
    goChanceList(){
      const vm=this
      vm.$router.push({ path:'/chanceList',query:{}})
    },
    playVideo(index){
      const vm=this;
      vm.videoPlay='play';
      if(index<0){
        vm.playerOptions.autoplay=true;
      }
      let str=`pcVideo${index}`
      $('.pcVideo').trigger('pause')
      $(`#${str}`).trigger('play')
    },
    onPlayerEnded(player){
      const vm=this;
      vm.videoPlay='end';
    },
    toReplay(){
      const vm=this;
      vm.videoPlay='play';
    },
    choiceVideo(index){
      const vm=this;
      vm.videosIndex=index;
      vm.videoPlay='play';
      vm.playerOptions.sources[0].src=vm.indexVideos[index].contentStr;
      vm.playerOptions.poster=vm.indexVideos[index].picStr;
      vm.indexBg=vm.indexVideos[index].picStr
      vm.playerOptions.autoplay=true;
    },
    queryvideos(){
      const vm=this;
      axios.post(
      `${config.urlList.queryUrl}/api/cbh/videos`,
      {
        is_recommend:1,
        per_page:9
      }).then(res => {
        if(res.data.code==1){
          let num=''
          res.data.data.data.forEach((da,index)=>{
            
            da.contentStr=`${config.urlList.imgUrl}${da.content}`
            da.picStr=`${config.urlList.imgUrl}${da.pic}`
            if(da.id==1){
              num=index
            }
          })
          if(res.data.data.data.length>0){
            if(vm.projectInfo.parent_id==2||vm.pageId==2){
              vm.playerOptions.sources[0].src=res.data.data.data[num].contentStr
              vm.indexBg=res.data.data.data[num].picStr
            }else{
              vm.playerOptions.sources[0].src=res.data.data.data[0].contentStr
              vm.indexBg=res.data.data.data[0].picStr
            }
          }
          vm.indexVideos=res.data.data.data
        }
      })
    },
  },
  created () {
    const vm = this;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted(){
    const vm=this;
    vm.pageId=vm.$route.query.id;
    vm.queryBanner();
    vm.queryProjectList(vm.pageId);
    vm.queryBlock();
    vm.queryBlock2();
    vm.queryEnterprisesList();
    vm.queryNewsList();
    vm.queryProject();
    setTimeout(()=>{
      var startX,endX;
      var offset = 50;
      $(".carousel").on('touchstart',function (e) {
        startX = e.originalEvent.touches[0].clientX;
      }).on('touchmove',function (e) {
        endX = e.originalEvent.touches[0].clientX;
      }).on('touchend',function (e) {
        var distance = Math.abs(startX - endX);
        if (distance > offset){
          $(this).carousel(startX >endX ? 'next':'prev');
        }
      })

      $('#carousel-example-generic5').on('slide.bs.carousel', function (obj) {
        vm.videosIndex = $(this).find('.item').index(obj.relatedTarget);
        vm.videoPlay='end';
        $('.pcVideo').trigger('pause')
      })
    },1200)
  }
}
</script>
<style scoped>
/**  轮播图公用样式  **/
.carousel-banner,.carousel-new-phone{
  position: relative;
}
.carousel-indicators li{
  margin: 0 5px !important;
  background: #fff!important;
  width: 10px!important;
  height: 10px!important;
}
.carousel-indicators .active{
  width: 24px!important;
  background: #49bc9b!important;
  border: none!important;
  height: 10px!important;
}

/**  pc 提示条样式  **/
.web-index-neck{
  font-size: 0.375rem;
  color: #000000;
  margin-top: 0.425rem;
  line-height: 1.6;
  position: relative;
  font-family:'wwf';
}
.web-index-neck::before{
  content: "";
  display: block;
  width: 0.75rem;
  height: 4px;
  background: #49bc9b;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

/**  web 提示条样式  **/
.phone-index-neck{
  font-size: 0.72rem;
  font-weight: 500;
  color: #000000;
  margin-top: 0.906rem;
  line-height: 2;
  position: relative;
  font-family:'wwf';
}
.phone-index-neck::before{
  content: "";
  display: block;
  width: 1.44rem;
  height: 4px;
  background: #cf6e32;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}


/**  pc banner  **/
.index-top-web{
  width: 100%;
  height: auto;
  position: relative;
}
.inner-item-img{
  width: 100%;
  height: 3.625rem;
}
.inner-item-center{
  padding: 0.225rem 0.25rem;
  background: rgba(0,0,0,0.5);
  border-radius: 4px;
  position: absolute;
  left: 0.5rem;
  top: 0.9375rem;
}
.item-center-title{
  font-size: 0.225rem;
  color: #fff;
  line-height: 1.2;
  font-family: 'wwf';
  width: 2.625rem;
  text-align: left;

}
.item-center-tips{
  width: 2.625rem;
  text-align: left;
  font-size: 0.1125rem;
  color: #fff;
  margin-top: 0.225rem;
}
.item-center-btn{
  width: 1.125rem;
  height: 0.3125rem;
  text-align: center;
  line-height: 0.3125rem;
  background: #49bc9b;
  font-size: 0.15rem;
  color: #ffffff;
  margin-top: 0.1875rem;
}

/**  web banner  **/
.index-top-phone{
  width: 100%;
  height: 8rem;
  position: relative;
}
.phone-inner-img{
  width: 100%;
  height: 8rem !important;
}
.phone-inner-center{
  padding: 0.48rem 0.53rem;
  background: rgba(0,0,0,0.5);
  border-radius: 4px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
.phone-center-title{
  font-size: .66rem;
  color: #fff;
  font-family: 'wwf';
  width: 7.8rem;
  text-align: left;
}
.phone-center-tips{
  margin-top: 0.45rem;
  font-size: 0.32rem;
  color: #fff;
  text-align: left;
}
.phone-center-btn{
  width: 2.667rem;
  height: .8rem;
  background: #49bc9b;
  margin-top: .5rem;
  font-size: .32rem;
  color: #fff;
  font-weight: 500;
  text-align: center;
  line-height: 0.8rem;
}

/**  pc项目介绍  **/
.index-neck{
  padding-bottom: 0.4rem;
}
.index-neck-tips{
  width: auto;
  padding: 0 0.5rem;
  margin: 0 auto;
  text-align: left;
  color: #000;
  font-size: 0.1125rem;
  line-height: 1.6;
  margin-top: 0.225rem;
}
.index-neck-tips /deep/ li{
  list-style: disc !important;
  margin-left: 0.22rem;
}
.index-neck-web{
  margin-top: 0.2875rem;
  padding: 0 0.5rem;
}
.index-neck-item{
  width: 100%;
  height: auto;
}
.neck-item-list,.hiddenHover{
  flex: 2;
  cursor: pointer;
  height: auto;
  min-height: 2.7rem;
  justify-content: flex-start;
}
.item-list-img{
  width: 1.275rem;
  height: 1.275rem;
}
.index-neck-indicators{
  bottom: -0.4rem;
}
.item-list-font{
  font-size: 0.26rem;
  line-height: 1.4;
  margin-top: 0.325rem;
  font-family: 'wwf';
}
.item-list-btns{
  display: none;
}
.neck-item-list:hover .item-list-img{
  width: 0.25rem;
  height: 0.25rem;
  border-radius: 50%;
}
.neck-item-list:hover .item-list-font{
  font-size: 0.24rem;
  margin-top: 0.1rem;
  font-family: 'wwf';
}
.neck-item-list:hover .item-list-btns{
  display: block;
}
.neck-item-list:hover{
  height: auto;
}
.list-btns-btn{
  width: 2rem;
  height: 0.28rem;
  text-align: center;
  line-height: 0.28rem;
  font-size: 0.12rem;
  margin-top: 0.1rem;
  font-family: 'wwf';
}
.neck-btn-left{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  left: 0.3rem;
  transform: translateY(-50%);
  color: #000;
}
.neck-btn-right{
  width: 0.4375rem;
  height: 0.4375rem;
  background: #fff;
  border-radius: 50%;
  box-shadow: 2px 2px 4px #c9c9c9;
  position: absolute;
  top: 50%;
  right: 0.3rem;
  transform: translateY(-50%);
  color: #000;
}

/**  web 项目介绍  **/
.phone-neck{
  padding: 0 0.5rem 1rem;
}
.phone-neck-tips{
  font-size: 0.32rem;
  color: #000;
  text-align: center;
  margin-top: 0.46rem;
}
.phone-neck-indicators{
  bottom: -1.2rem;
}
.phone-neck-item{
  width: 100%;
  height: auto;
}
.phone-item-list{
  flex: 2;
  height: auto;
  min-height: 9.4rem;
  justify-content: flex-start;
}
.phone-item-img{
  width: 2.4rem;
  height: 2.4rem;
}
.phone-item-font{
  font-size: 0.46rem;
  font-family: 'wwf';
  margin-top: 0.32rem;
}
.phone-btns-btn{
  width: 3.6rem;
  height: 0.9rem;
  font-size: 0.32rem;
  margin-top: 0.3rem;
  text-align: center;
  line-height: 0.9rem;
  font-family: 'wwf';
}

/**  pc  **/
.chance-neck{
  padding: 0.5rem;
  background: #e6edf9;
}
.web-chance-center{
  margin-top: 0.2875rem;
}
.chance-center-list{
  width: 2.75rem;
  height: 0.95rem;
  background: #fff;
  margin-right: 0.3625rem;
  margin-bottom: 0.2rem;
}
.chance-center-list:nth-child(3n){
  margin-right: 0;
}
.center-list-list{
  width: 100%;
  height: auto;
}

/**  web  **/
.phone-chance-center{
  margin-top: 0.4rem;
}
.phone-chance-center-list{
  width: 3.8rem;
  height: 2rem;
  background: #fff;
  margin-right: 0.5rem;
  margin-bottom: 0.3rem;
}
.phone-chance-center-list:nth-child(3n){
  margin-right: 0;
}
.phone-center-list-list{
  width: 100%;
  height: auto;
}

/**  pc 新闻动态  **/
.web-index-leg{
  padding: 0.3375rem 0.5rem 0;
  height: auto;
}
.index-leg-left{
  width: 4.3875rem;
  height: auto;
  box-shadow: 2px 2px 4px #c9c9c9;
}
.leg-left-top{
  width: 100%;
  height: auto;
  position: relative;
}
.leg-left-img{
  width: 100%;
  height: 2.5rem;
}
.left-top-bottom{
  position: absolute;
  bottom: 0;
  left: 0.1875rem;
  right: 0.1875rem;
  height: auto;
}
.top-bottom-list{
  padding: 0.075rem;
  font-size: 0.1rem;
  color: #ffffff;
  background: #32a5cf;
  line-height: 1;
  margin-bottom: 0.1875rem;
  margin-right: 0.1875rem;
  display: inline-block;
  float: left;
}
.left-top-bottom::after{
  content: '';
  display: block;
  clear: both;
}
.leg-left-center{
  padding: 0.1875rem;
  height: auto;
  background: #fff;
}
.left-center-title{
  font-size: 0.225rem;
  color: #000;
  font-family: 'wwf';
  text-align: left;
  line-height: 1.4;
  height: 0.63rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
}
.left-center-tips{
  font-size: 0.1125rem;
  color: #000;
  margin-top: 0.1rem;
  text-align: left;
  line-height: 1.4;
  height: 0.63rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 4;
  -webkit-box-orient: vertical;
}
.left-center-bottom{
  margin-top: 0.1875rem;
  cursor: pointer;
}
.center-bottom-left{
  font-size: 0.1125rem;
  color: #999999;
  text-align: left;
}
.index-leg-right{
  margin-left: 0.225rem;
  flex: 2;
  height: 4.534rem;
}
.leg-right-list{
  width: 100%;
  height: 1.25rem;
  box-shadow: 2px 2px 4px #c9c9c9;
}
.right-list-left{
  width: 1.875rem;
  min-width: 1.875rem;
  height: 1.25rem;
  position: relative;
}
.list-left-img{
  width: 100%;
  height: 100%;
}
.list-left-bottom{
  position: absolute;
  left: 0.0625rem;
  bottom: 0;
  right: 0.0625rem;
}
.list-left-bottom::after{
  content: "";
  display: block;
  clear: both;
}
.list-left-list{
  padding: 0.0625rem 0.075rem;
  font-size: 0.09375rem;
  color: #fff;
  background: #32a5cf;
  margin-bottom: 0.125rem;
  margin-right: 4px;
  float: left;
  line-height: 1;
}
.right-list-right{
  padding: 0.15rem;
  height: 1.25rem;
}
.list-right-title{
  font-size: 0.1875rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1.4;
  height: 0.525rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}
.right-list-bottom{
  width: 100%;
  cursor: pointer;
}

/**  web 新闻动态  **/
.phone-index-leg{
  margin-top: 0.74rem;
  padding: 0 0.5rem;
}
.phone-leg-top{
  width: 100%;
  height: auto;
  margin-bottom: 0.48rem;
  box-shadow: 2px 2px 4px #c9c9c9;
}
.leg-top-images{
  width: 100%;
  height: 5.334rem;
  position: relative;
}
.top-images-img{
  width: 100%;
  height: 100%;
}
.top-images-list{
  position: absolute;
  bottom: 0;
  left: 0.5rem;
  right: 0.5rem;
}
.top-images-list::after{
  content: "";
  display: block;
  clear: both;
}
.images-list-li{
  padding: 0.2rem 0.26rem;
  line-height: 1;
  color: #fff;
  font-size: 0.32rem;
  background: #436aba;
  margin-bottom: 0.25rem;
  margin-left: 0.25rem;
  display: inline-block;
  float: left;

}
.leg-top-bottom{
  padding: 0.56rem 0.48rem;
  background: #fff;
}
.top-bottom-title{
  font-size: 0.48rem;
  color: #000;
  font-family: 'wwf';
  line-height: 1.4;
  margin-bottom: 0.32rem;
  text-align: left;
}
.top-bottom-tips{
  font-size: 0.32rem;
  color: #000;
  line-height: 1.4;
  text-align: left;
}
.bottom-bottom-left{
  font-size: 0.32rem;
  color: #999;
}
.top-bottom-bottom{
  margin-top: 0.4rem;
}
.phone-leg-list{
  margin-bottom: 0.48rem;
  height: auto;
  box-shadow: 2px 2px 4px #c9c9c9;
}
.leg-list-left{
  width: 4rem;
  height: 2.667rem;
  position: relative;
}
.list-left-img{
  width: 100%;
  height: 100%;
}
.phone-list-bottom{
  position: absolute;
  left: 0.32rem;
  bottom: 0;
  right: 0.32rem;
}
.phone-list-bottom::after{
  content: "";
  display: block;
  clear: both;
}
.leg-list-right{
  padding: 0.3rem;
  height: 2.667rem;
  flex: 2;
}
.phone-list-title{
  font-size: 0.4rem;
  line-height: 1.4;
  height: 1.12rem;
  overflow : hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  text-align: left;
}
.top-bottom-bottom{
  width: 100%;
}

/**  pc视频播放  **/
.web-belly-center{
  width: 100%;
  height: auto;
  margin-top: 0.425rem;
  position: relative;
}
.belly-center-img{
  width: 100%;
  height: auto;
}
.belly-center-img /deep/ .vjs-poster{
  background-size: cover;
}
.belly-center-imgBtn{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 0.4rem;
  height: 0.4rem;
}
.web-belly-content{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5.125rem;
  z-index: 9;
}
.belly-top-font{
  margin-top: 0.5rem;
  border-bottom: 1px solid #fff;
  display: inline-block;
  height: 0.5rem;
  line-height: 0.5rem;
  cursor: pointer;
}
.belly-top-img{
  width: 0.2625rem;
  height: 0.2625rem;
  margin-right: 0.125rem;
  display: inline-block;
  vertical-align: text-bottom;
}
.belly-top-tips{
  font-size: 0.3rem;
  color: #fff;
  display: inline-block;
  font-family:'wwf';
}
.belly-content-center{
  padding: 0 0.5rem;
  margin-top: 0.575rem;
}
.content-center-list{
  width: 2.8125rem;
  height: auto;
}
.center-list-video{
  width: 2.8125rem;
  height: 1.4375rem;
  border: 4px solid #fff;
}
.center-list-font{
  font-size: 0.15rem;
  color: #fff;
  font-weight: 600;
  margin-top: 0.2125rem;
  font-family:'wwf';
}
.list-video-real{
  width: auto;
  height: 1.36rem;
}
.web-belly-btn{
  width: 1.25rem;
  height: 0.375rem;
  background: #49bc9b;
  font-size: 0.15rem;
  color: #fff;
  font-weight: 500;
  margin: 0.625rem auto 0;
  cursor: pointer;
  font-family:'wwf';

}

/**  web视频播放  **/
.phone-belly-center{
  margin-top: 0.667rem;
  width: 100%;
  height: 5.12rem;
  position: relative;
}
.phone-belly-img{
  width: 100%;
  height: 5.12rem;
}
.swiper-slide{
  position: relative;
  height: 100%;
}
.phone-belly-imgBtn{
  width: 1rem;
}


/**  web 8图项目介绍  **/
.index-belly-center{
  padding: 0.35rem 0.2rem;
  height: auto;
}
.centerWrap{
  flex-wrap: wrap;
}
.belly-center-all{
  width: 100%;
  height: auto;
}
.belly-center-div{
  width: 25%;
  height: auto;
}
.belly-center-list{
  width: 100%;
  padding-top: 100%;
  border-radius: 6px;
  margin-bottom: 3%;
  position: relative;
}
.belly-center-icon{
  width: 24px;
  height: 24px;
}
.center-icon-hidden{
  visibility: hidden;
}
/* .belly-center-icon:last-child{
  visibility: hidden;
} */
.center-list-li{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 6px;
}
.list-li-img{
  width: 100%;
  height: 100%;
  border-radius: 6px;
}
.list-li-layer{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(250, 250, 250, 0.6);
  border-radius: 6px;
}
.li-layer-font{
  font-size: 0.15rem;
  color: #333;
  padding: 0 0.2rem;
  position: absolute;
  top: 20%;
  left: 0;
  right: 0;
  bottom: 20%;
  text-align: left;
}
.li-layer-title{
  font-size: 0.15rem;
  color: #333;
  font-weight: 700;
  padding: 0 0.2rem;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 6%;
  text-align: left;
}
.belly-center-list:hover .list-li-layer{
  background: rgba(0, 0, 0, 0.6);
}
.belly-center-list:hover .li-layer-font,.belly-center-list:hover .li-layer-title{
  color: #fff;
}

/**  phone 8图项目介绍  **/
.phone-belly-centerImg{
  padding: 0.2rem 0.25rem;
  height: auto;

}
.phone-belly-imgList{
  width: 100%;
  padding-top: 100%;
  position: relative;
  border-radius: 6px;
  margin-bottom: 0.25rem;
}
.phone-belly-imgLi{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 6px;
}
.phone-belly-imgs{
  width: 100%;
  height: 100%;
}
.phone-belly-layer{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(250, 250, 250, 0.6);
  border-radius: 6px;
}
.phone-belly-font{
  font-size: 0.42rem;
  color: #333;
  padding: 0 0.2rem;
  position: absolute;
  top: 20%;
  left: 0;
  right: 0;
  bottom: 20%;
  text-align: left;
}
.phone-belly-title{
  font-size: 0.42rem;
  color: #333;
  font-weight: 700;
  padding: 0 0.2rem;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 6%;
  text-align: left;
}

/**  pc底部导航图  **/
.chance-leg{
  padding: 48px 0.5rem;
  height: auto;
  margin: 0.32rem 0;
  background: #f2f2f2;
  position: relative;
}
.chance-leg-top{
  position: absolute;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #f2f2f2;
  top: -40px;
  left: 50%;
  transform: translateX(-50%);
}
.leg-top-img{
  width: 16px;
  height: auto;
}
.chance-leg-list{
  width: 120px;
  height: 120px;
}
.leg-list-imgs{
  width: 100%;
  height: 100%;
}

.phone-chance-leg-list{
  width: 160px;
  height: 160px;
}
.phone-leg-list-imgs{
  width: 120px;
  height: 120px;
}
.mt{
  margin-top: -16px;
}

.color1{
  color: #32a5cf;
}
.color2{
  color: #436aba;
}
.color3{
  color: #ed9534;
}
.color4{
  color: #49bc9b;
}
.border1{
  border:1px solid #32a5cf;
}
.border2{
  border:1px solid #436aba;
}
.border3{
  border:1px solid #ed9534;
}
.border4{
  border:1px solid #49bc9b;
}
.bg1{
  background: #436aba;
}
.bg2{
  background: #ed9534;
}

.index-neck-btn{
  margin: 0.45rem auto 0;
  background-color: #5d266d;
  font-size: 0.125rem;
  color: #fff;
  width: 1.25rem;
  height: 0.375rem;
  border-radius: 0.375rem;
  text-align: center;
  line-height: 0.375rem;
}
</style>